import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Container,
  Tabs,
  Tab,
  Divider,
  colors
} from '@material-ui/core';
import Page from 'src/components/Page';
import Header from './Header';
import Timeline from './Timeline';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    marginTop: theme.spacing(3)
  },
  containerDetail: {
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(8),
    marginRight: theme.spacing(8),
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

function Profile({ match, history }) {
  const classes = useStyles();
  const { t } = useTranslation('common');

  const { id, tab: currentTab } = match.params;
  const tabs = [
    { value: 'timeline', label: t('Messages') },
  ];

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  if (!currentTab) {
    return <Redirect to={`/profile/${id}/timeline`} />;
  }

  if (!tabs.find((tab) => tab.value === currentTab)) {
    return <Redirect to="/errors/error-404" />;
  }

  return (
    <Page className={classes.root} title={t('Sirius Portal')}>
      <Header />
      <Container maxWidth="xl">
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="secondary"
          indicatorColor="primary"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </Tabs>
        <Divider className={classes.divider} />
        <div className={classes.content}>
          {currentTab === 'timeline' && <Timeline />}
        </div>
      </Container>
    </Page>
  );
}

Profile.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default Profile;
